import { render, staticRenderFns } from "./AgrDetail.vue?vue&type=template&id=fe1fda92&scoped=true&"
import script from "./AgrDetail.vue?vue&type=script&lang=js&"
export * from "./AgrDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgrDetail.vue?vue&type=style&index=0&id=fe1fda92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1fda92",
  null
  
)

export default component.exports